/** @jsx jsx */
import { jsx, Box, Styled } from "theme-ui"
import { Fragment } from "react"
import PropTypes from "prop-types"
import { graphql } from "gatsby"
import { MDXRenderer } from "gatsby-plugin-mdx"
import { MDXProvider } from "@mdx-js/react"

import Layout, { Container } from "components/layout"
import { Medium } from "components/type"
import shortcodes from "components/mdx"

import useLocales from "hooks/use-locales"

const PageTemplate = ({ data }) => {
  const { t } = useLocales()
  return (
    <Layout
      pageTitle={data.mdx.frontmatter.title}
      description={data.mdx.frontmatter.description}
    >
      {data.mdx ? (
        <Fragment>
          <Box sx={{ bg: "primary", py: 5, mb: 4 }}>
            <Container>
              <Styled.h1 sx={{ color: "background" }}>
                {data.mdx.frontmatter.title}
              </Styled.h1>
            </Container>
          </Box>
          <Container>
            <Medium sx={{ fontWeight: 500, mb: 5 }}>{t("tagline")}</Medium>
          </Container>
          <MDXProvider components={shortcodes}>
            <MDXRenderer>{data.mdx.body}</MDXRenderer>
          </MDXProvider>
        </Fragment>
      ) : (
        <div>{t("needsTranslation")}</div>
      )}
    </Layout>
  )
}

PageTemplate.propTypes = {
  data: PropTypes.shape({
    mdx: PropTypes.shape({
      frontmatter: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
      }),
      body: PropTypes.any,
    }),
  }),
}

export const query = graphql`
  query($locale: String!, $slug: String!) {
    mdx(
      fields: { locale: { eq: $locale } }
      frontmatter: { slug: { eq: $slug } }
    ) {
      frontmatter {
        title
        description
      }
      body
    }
  }
`

export default PageTemplate
